import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
  IOpenGraphService,
  OPEN_GRAPH_SERVICE
} from 'projects/suche-lib/src/lib/services/open-graph.service';
import { ThemenfelderComponent } from '../../../../../suche-lib/src/lib/pages/themenfelder/themenfelder.component';
import { RobotsService } from '../../service/robots.service';

@Component({
  selector: 'now-wbsuche-app-themenfelder',
  imports: [ThemenfelderComponent],
  templateUrl: './themenfelder-page.component.html'
})
export class ThemenfelderPageComponent implements OnInit, OnDestroy {
  private readonly openGraphService = inject<IOpenGraphService>(OPEN_GRAPH_SERVICE, {
    optional: true
  });
  private readonly robotsService = inject(RobotsService);

  constructor() {
    const title = inject(Title);

    title.setTitle('Weiterbildungssuche: Übersicht berufliche Themenfelder | mein NOW');
    this.openGraphService?.setDescription(
      'Nutzen Sie unsere Übersicht an beruflichen Themenfeldern für Ihre Weiterbildungssuche. Finden Sie geeignete Bildungsangebote passend zu Ihrem Berufsfeld.'
    );
  }

  // NOWSUCHE-3991 Themenfelder sollen indexiert werden
  ngOnInit(): void {
    this.robotsService.setIndexFollow();
  }

  ngOnDestroy() {
    this.robotsService.setNoIndexNoFollow();
  }
}
